const TGSS_IFRAME_PRE_ORIGIN = 'https://widget.qa.belender.net',
  TGSS_IFRAME_PRO_ORIGIN = 'https://widget.belender.net',
  WIDGET_HEIGHT_EVENT = 'widgetHeight';

export { TGSS_IFRAME_PRE_ORIGIN, TGSS_IFRAME_PRO_ORIGIN, WIDGET_HEIGHT_EVENT };
